var str_topseller = "";

function showAlphabet() {
	var alphabet = jQuery('ul', '#brands-alphabet');
	var elmts = jQuery('.hr-text', '#list-all-brands');
	var length = elmts.length;

	if(length>0){jQuery('#brands-alphabet').removeClass('hide');}

	for(var i=0; i<length; i++) {
		var hr_ref = elmts[i].id;
		alphabet.append("<li><a href='#" + hr_ref + "'>" + hr_ref + "</a></li>");
	}
}

/*
 * Load category items
 * VIEW: collection.json_filter.liquid
 * This function filters available items | Filter delivered within function-call in URL
 */
function loadCategory(cat_json, display_index) {
	var threshold = parseInt("60");
	animateMore();

	console.log(cat_json);

	var unhidden;
	if(display_index) {
		unhidden = display_index;
	} else if(display_index == 0) {
		unhidden = 0;
	} else {
		// Initial
		unhidden = false;
		jQuery('#p_button').attr("sold-out-items", "false");
		jQuery('#p_content').empty();
	}
	
	var collection_results = jQuery.get(
		cat_json,
		function(data) {
			var response = jQuery.parseJSON(data);
			if(response.results.length == 0 && response.pages == 1) {
				jQuery('#p_content').append('<div class="grid__item gutter--small d-font16 m-font22">Leider konnten wir keine Produkte finden</div>');
				jQuery('#footnotes').hide();
			}
			var res_avail = response.results.filter(function (obj) {
				return obj.availability == true;
			});

			if(response.results.length > res_avail.length) {
				jQuery('#p_button').attr("sold-out-items", "true");
			}
				
			var i = 0;
			if(unhidden) {
				i = unhidden;
			}
			jQuery('#p_button').empty();

			// Iterate through filtered response
			var p_content = jQuery('#p_content'), length = res_avail.length, hide = false, threshold_reached = false;
			for(var j=0; j<length; j++) {
				i+=1;
				if(i > threshold) { i=1; hide = true; threshold_reached = true; }
				p_content.append(product_item_template(res_avail[j], "category-item", true, true, i, hide));
			}

			loadMore("category-item", cat_json, response.page_next_url, i, threshold_reached);
		}
	)
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.warn("ajax failed: " + errorThrown);
		animateMoreStop();
	});
}

/*
 * Load unavailable category items
 * VIEW: collection.json_filter_unavail.liquid
 * This function filters unavailable items | Filter delivered within function-call in URL
 */
function loadCategoryUnavail(cat_json, display_index) {
	var threshold = parseInt("60");
	if(jQuery('#p_soldout').length>0) {
		animateSoldout();
	} else {
		animateMore();
	}
	var cat_results = jQuery.get(
		cat_json,
		function(data) {
			var response = jQuery.parseJSON(data);
			var res_unavail = response.results;

			var p_content = jQuery('#p_content');
			var length = res_unavail.length;
			var i = display_index;
			
			for(var j=0; j<length; j++) {
				i+=1;
				if(i > threshold) { i=1; }
				p_content.append(product_item_template(res_unavail[j], "catgegory-item", false, true, i, false));
			}

			if(response.page_next_url) {
				loadCategoryUnavail(response.page_next_url);
			} else {
				animateMoreStop();
				animateSoldoutStop();
				set_height_overview();
			}
		}
	)
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.warn("ajax failed: " + errorThrown);
		animateMoreStop();
		animateSoldoutStop();
	});
}

/*
 * Load collection items
 * VIEW: collection.json_filter.liquid
 * This function filters available items | Filter delivered within function-call in URL
 */
function loadCollection(coll_json, digitalSignage, display_index) {
	var threshold = parseInt("60");
	animateMore();

	var unhidden;
	if(display_index) {
		unhidden = display_index;
	} else if(display_index == 0) {
		unhidden = 0;
	} else {
		unhidden = false;
		jQuery('#p_button').attr("sold-out-items", "false");
		jQuery('#p_content').empty();
	}

	var collection_results = jQuery.get(
		coll_json,
		function(data) {
			var response = jQuery.parseJSON(data);
			if(response.results.length == 0 && response.pages == 1) {
				jQuery('#p_content').append('<div class="grid__item gutter--small d-font16 m-font22">Leider konnten wir keine Produkte finden</div>');
				jQuery('#footnotes').hide();
			}
			var res_avail = response.results.filter(function (obj) {
				return obj.availability == true;
			});

			if(response.results.length > res_avail.length && !digitalSignage) {
				jQuery('#p_button').attr("sold-out-items", "true");
			}
				
			var i = 0;
			if(unhidden) {
				i = unhidden;
			}
			jQuery('#p_button').empty();

			// Iterate through filtered response
			var p_content = jQuery('#p_content'), length = res_avail.length, hide = false, threshold_reached = false;
			
			for(var j=0; j<length; j++) {
				i+=1;
				if(i > threshold) { i=1; hide = true; threshold_reached = true; }
				p_content.append(product_item_template(res_avail[j], "collection-item", true, false, i, hide));
			}

			loadMore("collection-item", coll_json, response.page_next_url, i, threshold_reached);
		}
	)
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.warn("ajax failed: " + errorThrown);
		animateMoreStop();
	});
}

/*
 * Load unavailable collection items
 * VIEW: collection.json_filter_unavail_x.liquid
 * This function filters unavailable items | Filter delivered within function-call in URL
 */
function loadCollectionUnavail(coll_json, display_index) {
	var threshold = parseInt("60");
	if(jQuery('#p_soldout').length>0) {
		animateSoldout();
	} else {
		animateMore();
	}
	
	var cat_results = jQuery.get(
		coll_json,
		function(data) {
			var response = jQuery.parseJSON(data);
			var res_unavail = response.results;

			var p_content = jQuery('#p_content');
			var length = res_unavail.length;
			var i = display_index;
			
			for(var j=0; j<length; j++) {
				i+=1;
				if(i > threshold) { i=1; }
				p_content.append(product_item_template(res_unavail[j], "collection-item", false, false, i, false));
			}

			if(response.page_next_url) {
				loadCollectionUnavail(response.page_next_url, i);
			} else {
				animateMoreStop();
				animateSoldoutStop();
				set_height_overview();
			}
		}
	)
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.warn("ajax failed: " + errorThrown);
		animateMoreStop();
		animateSoldoutStop();
	});
}

/*
 * Search results are by default limited to 10
 * VIEW: search.json_filter.liquid
 * search.json_filter.liquid re-structures results by pagination (set in settings_data)
 * This function filters available items
 */
function loadSearchResults(search_json, display_index) {
	//debugger;
	var threshold = parseInt("60");
	animateMore();

	var unhidden;
	if(display_index) {
		unhidden = display_index;
	} else if(display_index == 0) {
		unhidden = 0;
	} else {
		// Initial
		unhidden = false;
		jQuery('#p_button').attr("sold-out-items", "false");
		jQuery('#p_content').empty();
	}

	var search_results = jQuery.getJSON(
		search_json,
		function(response) {
			if(response.results.length == 0 && response.pages == 1) {
				jQuery('#p_content').append('<div class="grid__item gutter--small d-font16 m-font22">Leider konnten wir keine Produkte finden</div>');
				jQuery('#footnotes').hide();
			}
			var res_avail = response.results.filter(function (obj) {
				return obj.availability == true;
			});

			if(response.results.length > res_avail.length) {
				jQuery('#p_button').attr("sold-out-items", "true");
			}

			if(response.page < response.pages) {
				var page_next_url = response.page_next_url;
			} else {
				page_next_url = false;
			}
			
			var i = 0;
			if(unhidden) {
				i = unhidden;
			}
			jQuery('#p_button').empty();

			// Iterate through filtered response
			var p_content = jQuery('#p_content'), length = res_avail.length, hide = false, threshold_reached = false;
			for(var j=0; j<length; j++) {
				i+=1;
				if(i > threshold) { i=1; hide = true; threshold_reached = true; }
				p_content.append(product_item_template(res_avail[j], "search-item", true, true, i, hide));
			}

			loadMore("search-item", search_json, page_next_url, i, threshold_reached);
		}
	)
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.warn("ajax failed: " + errorThrown);
		animateMoreStop();
	});
}

/*
 * Search results are by default limited to 10
 * VIEW: search.json_filter.liquid
 * search.json_filter.liquid re-structures results by pagination (set in settings_data)
 * This function filters available items
 */
function loadSearchResultsUnavail(search_json, display_index) {
	var threshold = parseInt("60");
	if(jQuery('#p_soldout').length>0) {
		animateSoldout();
	} else {
		animateMore();
	}
	var search_results = jQuery.getJSON(
		search_json,
		function(response) {
			var p_content = jQuery('#p_content');
			var length = response.results.length;
			var i = display_index;
			
			for(var j=0; j<length; j++) {
				i+=1;
				if(i > threshold) { i=1; }
				p_content.append(product_item_template(response.results[j], "search-item", false, true, i, false));
			}

			if(response.page_next_url) {
				loadSearchResultsUnavail(response.page_next_url);
			} else {
				animateMoreStop();
				animateSoldoutStop();
				set_height_overview();
			}
		}
	)
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.warn("ajax failed: " + errorThrown);
		animateMoreStop();
		animateSoldoutStop();
	});
}

/**
 * product-item-template for AJAX requests
 * @param {Object}			item - product object from shop response
 * @param {string}			item_name - { "search-item", "collection-item", "category-item" }
 * @param {boolean}			available
 * @param {boolean}			logo - show vendor logo?
 * @param {number}			i - will show data-index=i & reference for item (m)border
 * @param {boolean}			hide - add class 'hide'?
 */
function product_item_template(item, item_name, available, logo, i, hide) {
	var item_vendor = item.vendor.replace("Annemarie Börlind", "ANNEMARIE BÖRLIND");
	var onlyTitle = "La Mer,Kilian,BOIS 1920";
	
	// stagingBrands is defined in snippet '_staging.liquid'
	var staging = stagingBrands.indexOf(item.vendor_logo) > 0 || stagingBrands.indexOf(item_vendor) > 0 ? true : false;
	
	var border_class = "", cycle = "";
	var items = jQuery('#p_content>.collection-item');
	var c = items.length;

	var item_topseller = false;
	if(str_topseller.includes(item.id)) {
		item_topseller = true;
	}
	
	if(c > 3) { border_class = "border"; }
	else if(i > 2 && i < 5) { border_class = "mborder"; }

	var _cycle="", _cyclem, refname = "refname_"+Math.ceil((c+1)/4);
	if([1,5,9,13,17].includes(i)) { _cyclem="item4_m"; _cycle="item4_1"; }
	if([2,6,10,14,18].includes(i)) { _cyclem="item4_m"; }
	if([3,7,11,15,19].includes(i)) { _cyclem="item4_2m"; }
	if([4,8,12,16,20].includes(i)) { _cyclem="item4_2m"; }

	var content =	'<div data-index="' + i + '" name="' + item_name + '" class="grid__item gutter--small desktop--one-quarter mobile--one-half collection-item ' + border_class + ' ' + (hide ? "hide" : "") + '" style="' + (available ? "" : "opacity: 0.3") + '">' +
						'<a href="' + item.url + '?variant=' + item.variantid + '" title="' + item.title + '" name="Product-Container">' +
							'<div class="product-container' + (logo ? " with-logo" : "") + '">' +
								'<div class="product-image ">' +
									'<div class="product-thumbnail">' +
										'<div class="pseudo-parent">' +
											'<div class="bottom-center-child ' + (hide ? "lazy_load" : "") + '">';

						if(hide) {
							content +=			'<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-src="' + item.image + '" alt="' + item.title + '" name="ProductPhotoImg" onerror="this.src=\'https://cdn.beautyavenue.de/images/products/178x178/no-picture-ba.svg\' ">' +
											'</div>';
						} else {
							content +=			'<img src="' + item.image + '" alt="' + item.title + '" name="ProductPhotoImg" onerror="this.src=\'https://cdn.beautyavenue.de/images/products/178x178/no-picture-ba.svg\' ">' +
											'</div>';
						}

						if(staging) {
							content +=		'<div class="stagingLayOver">' +
												'<img src=\"//www.beautyavenue.de/cdn/shop/t/20/assets/staging.png?v=158241414575891384691660740736\" />' +
											'</div>';
						}
						
						content +=		'</div>' +
									'</div>' +
									'<div name="' + refname + '" class="product-meta ' + _cycle + '">';

						if(logo) {
							content +=	'<div class="logo-pseudo-parent">' +
											'<div class="pseudo-child">' +
												'<div class="logo-container">' +
													'<img src="' + item.vendor_logo + '" onload="scale_height(this)" class="vcenter hide" role="img" aria-label="' + item_vendor + '" alt="' + item_vendor + '">' +
												'</div>' +
											'</div>' +
										'</div>';
						}

						content += 		'<div name="height_text" class="d-font12 m-font22 ' + _cyclem + ' responsive-height_text" brandine="' + item.vendor + '" line="' + item.line + '">';
						
						if(item.vendor.toLowerCase() == "jo malone") {
							// BAP900-1416
							content +=		'<h5 class="activefont black d-font12 m-font22 overflow" name="vendorcase">' + (item.title.replace(item.vendor, "").replace(item.type, "")) + '</h5>' +
											'<h6 class="d-font10 m-font19">' + item.type + '</h6>';
						} else if(item.vendor.toLowerCase() == "kilian paris") {
							// DEVBUG-35750
							content +=		'<h5 class="activefont black d-font12 m-font22 overflow" name="vendorcase">' + (item.line.replace(item.vendor, "").replace("Kilian", "")) + '</h5>' +
											'<h6 class="d-font10 m-font19">' + item.brandline + '</h6>';
						} else if(onlyTitle.indexOf(item.vendor) > -1) {
							content +=		'<h5 class="activefont black d-font12 m-font22 overflow" name="vendorcase">' + item.brandline + '</h5>';
						} else {
							content +=		'<h5 class="activefont black d-font12 m-font22 overflow" name="vendorcase">' + (item.line ? item.line : item_vendor) + '</h5>' +
											'<h6 class="d-font10 m-font19">' + item.brandline + '</h6>';
						}

						content +=		'</div>' +
									'</div>' +
									'<br />' +
									'<div class="product-meta-price d-font10 m-font17">';
						
						if(available) {
							content += 	'<h5 class="activefont black d-font12 m-font22 ' + (globalDiscountActive === true ? "linethrough" : "") + '">' + item.lowestprice + '</h5>';
							if (globalDiscountActive) {
								content += 	'<h5 class="activefont black d-font12 m-font22">' + item.lowestpriceDiscount + '</h5>';
							}
							if(item.sale) {
								content += '<div class="label_container" style="background-color: #ff2a63; border: 2px solid #ff2a63;">' +
												'<div class="activefont white labelfontfix">Sale</div>' +
											'</div>';
							} else if(item.baseprice) {
								content += '<h6 class="d-font8 m-font12">' + (globalDiscountActive === true ? item.basepriceDiscount : item.baseprice) + '</h6>';
							}
							if(item_topseller) {
								content += '<div class="label_container" style="border: 2px solid #000">' +
												'<div class="activefont labelfontfix" style="color: #000;">Topseller</div>' +
											'</div>';
							} else if(item.neuheit) {
								content += '<div class="label_container" style="background-color: #1C9700; border: 2px solid #1C9700">' +
												'<div class="activefont labelfontfix" style="color: #FFF;">Neuheit</div>' +
											'</div>';
							}
						} else {
							content +=	'<h5 class="activefont black d-font12 m-font22">Ausverkauft</h6>'
						}
									'</div>' +
								'</div>' +
							'</div>' +
						'</a>' +
					'</div>';
	return content;
}

/**
 * Load BTN more template
 * @param {string}			item_name - { "search-item", "collection-item", "category-item" }
 * @param {string}			url - URL to json
 * @param {string|false}	url_next - URL to json next page
 */
function load_btn_more(item_name, url, url_next) {
	jQuery('#p_button').empty();
    var btn = '<a onclick="loadMore(\'' + item_name + '\', \'' + url + '\', \'' + url_next + '\', -1, false)">' +
                '<button class="btn activefont d-font12 m-font21">' +
                  '<div style="position: relative;">' +
                    '<div class="text">Mehr Produkte</div>' +
                  '</div>' +
                '</button>' +
              '</a>';
	jQuery('#p_button').html(btn);
}

/**
 * Load BTN unavail template
 * @param {string}			item_name - { "search-item", "collection-item", "category-item" }
 * @param {string}			url
 * @param {number}			i - reference for item (m)border
 */
function load_btn_unavail(item_name, url, i) {
	jQuery('#p_soldout').remove();
	jQuery('#p_button').empty();

	if(url.indexOf("jo-malone") > -1) {
		return;
	}

	var border_class = "";
	var c = jQuery('#p_content>.collection-item').length;
	
	if(c > 3) { border_class = "border"; }
	else if(i > 2 && i < 5) { border_class = "mborder"; }
	i+=1;	// cycle iteration

	var field =	'<div id="p_soldout" class="grid__item gutter--small desktop--one-quarter mobile--one-half collection-item ' + border_class + '">' +
					'<div class="pseudo-parent shadow activefont light_grey d-font12 m-font22">' +	// pink--hover">' +
						'<div class="center-child">' +
							'<div class="vcenter">' +
							'<div class="text">Ausverkaufte<br />Produkte</div>' +
							'</div>' +
							'<img class="hide vcenter-abs loading-soldout" src="//www.beautyavenue.de/cdn/shop/t/20/assets/loading-soldout.gif?v=130859854710149617111660740727"></div>' +
						'</div>' +
					'</div>' +
				'</div>';
	jQuery('#p_content').append(field);
	
	// remove parameter page with regex
	var regex = new RegExp("\(&page=\([0-9][0-9]|[0-9]\)\)|\(page=\([0-9][0-9]|[0-9]\)&\)", "i");
	url = url.replace(regex, "");

	var loadFunction = "";
	switch(item_name) {
		case "search-item":
			//loadFunction = "loadSearchResultsUnavail";
			url = url.replace("json_filter", "json_filter_unavail");
			loadSearchResultsUnavail(url, i);
			break;
		case "category-item":
			//loadFunction = "loadCategoryUnavail";
			url = url.replace("json_filter", "json_filter_unavail");
			loadCategoryUnavail(url, i);
			break;
		case "collection-item":
			//loadFunction = "loadCollectionUnavail";
			url = url.replace("json_filter", "json_filter_unavail");
			loadCollectionUnavail(url, i);
			break;
		default:
			console.warn("no valid item referrer");
	}
}

/**
 * load more items - Template for all item types
 * @param {string}			item_name - { "search-item", "collection-item", "category-item" }
 * @param {string}			json_cur - Current page URL
 * @param {string|false}	json_next - Next page URL
 * @param {number}			i_ntermediate - Index of last undisclosed product-item
 * @param {boolean}			threshold_reached - Theshold+ products loaded, index will be misleading 
 */
function loadMore(item_name, json_cur, json_next, i_ntermediate, threshold_reached) {
	var threshold = parseInt("60");

	// only for better handling
	if(json_next == "false") { json_next = false; }
	
	if(i_ntermediate >= 0) {
		var i=i_ntermediate;
	} else {
	  	var i=0;
	}
	
	if(threshold_reached == false) {
		jQuery('[name="' + item_name + '"].hide').each(function() {
			var img = jQuery(this).find('.lazy_load img');
			img.attr('src', img.attr('data-src'));	// lazy_load
			jQuery(this).removeClass('hide');
			i += 1;        
			if(i == threshold) { return false; }
		});
	}
	set_height_overview();
  
	if(i==threshold) {
		animateMoreStop();
		if(jQuery('[name="' + item_name + '"]').last().hasClass('hide') || json_next){
			load_btn_more(item_name, json_cur, json_next);
		} else if(jQuery('#p_button').attr("sold-out-items") == "true") {
			load_btn_unavail(item_name, json_cur, i);
		}
	} else if(threshold_reached) {
		animateMoreStop();
		load_btn_more(item_name, json_cur, json_next);
	} else if(i<threshold) {
		if(json_next) {
			switch(item_name) {
				case "search-item":
					loadSearchResults(json_next, i);
					break;
				case "category-item":
					loadCategory(json_next, i);
					break;
				case "collection-item":
					loadCollection(json_next, false, i);
					break;
				default:
					console.warn("no valid item referrer");
			}
		} else if(jQuery('#p_button').attr("sold-out-items") == "true") {
			if(jQuery('[name="' + item_name + '"]').length > 0) {
				animateMoreStop();				
				load_btn_unavail(item_name, json_cur, i);
			} else {
				// remove parameter page with regex
				var regex = new RegExp("\(&page=\([0-9][0-9]|[0-9]\)\)|\(page=\([0-9][0-9]|[0-9]\)&\)", "i");
				json_cur = json_cur.replace(regex, "");
				
				jQuery('#p_button').empty();
				
				switch(item_name) {
					case "search-item":
						json_cur = json_cur.replace("json_filter", "json_filter_unavail");
						loadSearchResultsUnavail(json_cur, i);
						break;
					case "category-item":
						json_cur = json_cur.replace("json_filter", "json_filter_unavail");
						loadCategoryUnavail(json_cur, i);
						break;
					case "collection-item":
						json_cur = json_cur.replace("json_filter", "json_filter_unavail");
						loadCollectionUnavail(json_cur, i);
						break;
					default:
						console.warn("no valid item referrer");
				}
			}
		} else {
			animateMoreStop();
			jQuery('#p_button').empty();
		}
	}
}

/*
 * Get SVG attribute heigth & width to scale properly
 * Avoids iming issue with JS when using naturalHeigth & naturalWidth
 */
function scale_height(img) {
	jQuery.get(jQuery(img).attr('src'), function(data) {
		var height = jQuery(data).find('svg').attr('height');
		if(!height) { height = '80'; } // %

		var brand = jQuery(img).attr('alt').toLowerCase();
		
		if(brand.indexOf("gruber") > -1 || brand.indexOf("pharmos") > -1) {
			jQuery(img).css({"transform": "scale(1.7)", "top": "5%"}).addClass("scale-height").removeClass('hide');
		} else {
			jQuery(img).css('height', height + '%').addClass("scale-height").removeClass('hide');
		}
	})
	.fail(function( jqXHR, textStatus, errorThrown ) {
		jQuery(img).addClass("scale-height").removeClass('hide');	/* IE9 won't allow Cross-Domain-Request */
	});
}

function scale_width(img) {
	jQuery.get(jQuery(img).attr('src'), function(data) {
		var width = jQuery(data).find('svg').attr('width');
		width = (width / 400) * 100;
		jQuery(img).css('width', width + '%').addClass("scale-width").removeClass('hide');
	})
	.fail(function( jqXHR, textStatus, errorThrown ) {
		console.error(errorThrown);
		jQuery(img).addClass("scale-width").removeClass('hide');	/* IE9 won't allow Cross-Domain-Request */
	});
}

function adapt_height() {
	var header = jQuery('#coll_header');
	var img = jQuery('#coll_header_logo');
	
	if(img.height() > header.children().height()) {
		header.height(img.height());
	}
	header.css("visibility", "visible");
}

function scale_headlogo_width(adapt) {
	var img = jQuery('#coll_header_logo');

	jQuery.get(img.attr('src'), function(data) {
		var width = jQuery(data).find('svg').attr('width') * "1.4";
		width = (width / "560") * 100;
		img.css("width", width + "%");

		if(adapt) {
			adapt_height();
		}
	});
}

function animateMore() {
	jQuery('#p_button').addClass('hide');
	jQuery('#p_loading').removeClass('hide');
}

function animateMoreStop() {
	jQuery('#p_loading').addClass('hide');
	jQuery('#p_button').removeClass('hide');
}

function animateSoldout() {
	var b = jQuery('#p_soldout');
		b.find('.text').css('visibility', 'hidden');
		b.find('img').removeClass('hide');
		b.find('.shadow').removeClass('pink--hover');
		b.find('a').removeAttr('onclick').addClass('no-pointer');
};

function animateSoldoutStop() {
	var b = jQuery('#p_soldout');
		b.find('.text').css('visibility', 'visible');
		b.find('img').addClass('hide');
}

function lazy_load() {
	jQuery('[name="lazy_load"]').each(function() {
		jQuery(this).attr('src', jQuery(this).attr('data-src'));	// lazy_load
	});
}

/**
 * Checkbox - Toggle GiftOption
 * @param {HTMLInputElement}		elmt			- input type="checkbox"
 * @param {string}					giftOptionSKU	- "Geschenkoption" | append: item.sku
 * @param {string}					giftWrapRef		- GiftWrap-Variant-ID (to add) or CartItem-Key (for update)
 * @param {string}					curGiftWrapQty		- current quantity
 */
function giftWrappingToggle_Qty(elmt, giftOptionSKU, giftWrapRef, curGiftWrapQty) {
	var giftCountID = '#'+giftOptionSKU+'_giftCount';
	var cntForSKU = parseInt(jQuery(giftCountID).text());
	var curCntForCart = parseInt(curGiftWrapQty);
	var newCntForCart = curCntForCart;

	if(jQuery(elmt).is(':checked'))
	{
    	jQuery.post('/cart/update.js', "attributes[" + giftOptionSKU + "]="+cntForSKU);
		newCntForCart += cntForSKU
	} else {
		jQuery.post('/cart/update.js', "attributes[" + giftOptionSKU + "]=Nein");
		newCntForCart -= cntForSKU;
	}
	
	setTimeout(function(){
		if(curCntForCart > 0) {
			giftWrapItemUpdate(giftWrapRef, newCntForCart);
		} else {
			// No GiftWrap added to cart yet
			giftWrapItemAdd(giftWrapRef, newCntForCart);
		}
	},500);
}

function giftWrappingUpdateAttribute(giftOptionSKU, newValue) {
	jQuery.post('/cart/update.js', "attributes[" + giftOptionSKU + "]="+newValue);

	setTimeout(function(){
		//location.reload();
		window.location.href="/cart";
	},500);
}

// set GiftWrap-Attribute to 'Nein' (inactive)
function giftWrappingRemoveAttribute(giftOptionSKU) {
	jQuery.post('/cart/update.js', "attributes[" + giftOptionSKU + "]=Nein");
}

/**
 * Checkbox - Toggle GiftOption
 * @param {HTMLInputElement}		elmt			- input type="checkbox"
 * @param {string}					maxCnt			- current item quantity (= max giftWrap-Qty)
 * @param {string}					giftOptionSKU	- "Geschenkoption" | append: item.sku
 * @param {string}					giftWrapRef		- GiftWrap-Variant-ID (to add) or CartItem-Key (for update)
 * @param {string}					curGiftWrapQty		- current quantity
 */
function giftWrappingQty(elmt, maxCnt, giftOptionSKU, giftWrapRef, curGiftWrapQty) {
	var giftCountID = '#'+giftOptionSKU+'_giftCount';
	var giftCountDownID = '#'+giftOptionSKU+'_giftCountDown';
	var giftCountUpID = '#'+giftOptionSKU+'_giftCountUp';
	var giftCheckBoxID = '#'+giftOptionSKU+'_checkbox';
	
	var curCntForSKU = parseInt(jQuery(giftCountID).text());
	var newCntForSKU = curCntForSKU;
	var curCntForCart = parseInt(curGiftWrapQty);
	var newCntForCart = curCntForCart;
	var int_giftWrapRef = parseInt(giftWrapRef);

	if(jQuery(elmt).attr('id').indexOf("giftCountDown") > -1 && curCntForSKU > 1)
	{
		// Reduce
		newCntForSKU = newCntForSKU - 1;
		newCntForCart = curCntForCart - 1;
	}
	else if(jQuery(elmt).attr('id').indexOf("giftCountUp") > -1 && curCntForSKU < maxCnt)
	{
		// Add-Up
		newCntForSKU = newCntForSKU + 1
		newCntForCart = curCntForCart + 1;
	}

	// Update Qty in Text
	jQuery(giftCountID).text(newCntForSKU);

	// Disable buttons if max reached
	if(newCntForSKU <= 1)
	{
		jQuery(giftCountDownID).addClass('disabled');
	} else {
		jQuery(giftCountDownID).removeClass('disabled');
	}
	if(newCntForSKU >= maxCnt)
	{
		jQuery(giftCountUpID).addClass('disabled');
	} else {
		jQuery(giftCountUpID).removeClass('disabled');
	}

	if(jQuery(giftCheckBoxID).is(':checked'))
	{
    	jQuery.post('/cart/update.js', "attributes[" + giftOptionSKU + "]=" + newCntForSKU);

		setTimeout(function(){
			if(curCntForCart > 0) {
				giftWrapItemUpdate(int_giftWrapRef, newCntForCart);
			} else {
				// No GiftWrap added to cart yet
				giftWrapItemAdd(int_giftWrapRef, newCntForCart);
			}
		},1000);
	} else {
		jQuery.post('/cart/update.js', "attributes[" + giftOptionSKU + "]=Nein");
	}
}

/**
 * Add item to cart
 * @param {bigint}			variantID		- Shopify variantId
 * @param {int}				quantity		- quantity to add
 */
function giftWrapItemAdd(variantID, quantity) {
	jQuery.post('/cart/add.js', {
		items: [{
			quantity: quantity,
			id: parseInt(variantID)
		}]
	});

	setTimeout(function(){
		//location.reload();
		window.location.href="/cart";
	},500);
}

/**
 * Update quantity for item
 * @param {bigint}			lineItemKey		- Cart item key
 * @param {int}				quantity		- quantity to update
 */
function giftWrapItemUpdate(lineItemKey, quantity) {
	jQuery.post('/cart/change.js', {
		quantity: quantity,
		id: lineItemKey
	});

	setTimeout(function(){
		//location.reload();
		window.location.href="/cart";
	},500);
}

/*
 * Adjust product item height (Collection & Search)
 */
function set_height_overview() {
	if(jQuery('.product-meta.item4_1').length>0) {
		var fontSize = getComputedStyle(jQuery('[name="height_text"]')[0]).fontSize;
		var len = jQuery('.product-meta.item4_1').length;

		var last_ref = jQuery('.product-meta.item4_1x').attr('name');
		var last_elmts = document.getElementsByName(last_ref);
		jQuery(last_elmts).removeClass('item4_1x').children('[name="height_text"]').removeAttr('style');

		jQuery('.product-meta.item4_1').each(function(index, obj) {
			if(this.clientHeight>0) {	// hidden if zero
				var name = this.getAttribute('name');
				var elmts = document.getElementsByName(name);
				var _arr = [], _arr2 = [], _arr2m = [];
				
				/************ Desc ************/
				jQuery(elmts).each(function() {
					var item = this.querySelector('[name="height_text"]');
					var h = item.clientHeight;
					if(!_arr.includes(h)) {_arr.push(h); }
					if(jQuery(item).hasClass('item4_m') && !_arr2.includes(h)) { _arr2.push(h); }
					if(jQuery(item).hasClass('item4_2m') && !_arr2m.includes(h)) { _arr2m.push(h); }
				});
				
				if(_arr.length > 1) { // are there even diff heights?
					var max_desc = Math.max.apply(null, _arr)/parseInt(fontSize)+'em';

					if(_arr2.length > 1) {	// is height diff for item 3 / 4
						var max_desc2 = Math.max.apply(null, _arr2)/parseInt(fontSize)+'em';
						jQuery(elmts).children('[name="height_text"].item4_m').attr('style', 'height:'+max_desc+';min-height:'+max_desc2);
					} else { jQuery(elmts).children('[name="height_text"].item4_m').height(max_desc); }
					if(_arr2m.length > 1) {	// is height diff for item 3 / 4
						var max_desc2m = Math.max.apply(null, _arr2m)/parseInt(fontSize)+'em';
						jQuery(elmts).children('[name="height_text"].item4_2m').attr('style', 'height:'+max_desc+';min-height:'+max_desc2m);
					} else {
						jQuery(elmts).children('[name="height_text"].item4_2m').height(max_desc); }
				}
				if((index+1) != len && elmts.length == 4) {
					jQuery(this).removeClass('item4_1');	// to prevent re-treatment in next cycle
				} else {
					jQuery(this).addClass('item4_1x');
				}
			}
		});
	}
}

/*
 * Adjust product item height (Index & Related Products)
 * @param {string}			obj - Collection-Handle as ID
 */
function set_height_index(id) {
	jQuery('#'+id+' [name="height_text"]').css('height', 'unset').height('unset');

	/************ Desc ************/
	var height_text = jQuery('#'+id+' [name="height_text"]');
	var _arr = [];
	jQuery(height_text).each(function() {
		if(!_arr.includes(this.clientHeight)) { _arr.push(this.clientHeight); }
	});
	if(_arr.length > 1) {
		var max_desc = Math.max.apply(null, _arr);
		var fontSize = getComputedStyle(height_text[0]).fontSize;
		jQuery(height_text).height((max_desc/parseInt(fontSize))+'em');
	}
}

function getDuration(target, rate) {
    var currentTop = jQuery(window).scrollTop(),
            rate, //0.5 =  1000px/500ms
            distance;
    distance = Math.abs(currentTop - target);
    return distance * rate;
}

function sendMail(message, debug, store = "") {
	if (debug)
	{
		jQuery.ajax({
			type : "POST",
			url  : "https://redirect.beautyavenue.de/shop/raspi_log.php",
			data : { message_debug : message, store : store }
		});
	}
	else {
		jQuery.ajax({
			type : "POST",
			url  : "https://redirect.beautyavenue.de/shop/raspi_log.php",
			data : { message : message, store : store }
		});
	}
}

/*
 *
 * ITS-6402
 * Scrolling through collections
 *
 */
function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

function callUrl(screen, url, retries) {
	//sendMail(screen + ": Retries (TMP) -> " + retries.toString(), true, screen);

	jQuery.ajax({
		type: 'GET',
		url: url
	})
	.done(function( data ) {
		sendMail(screen + ": Retries (Done) -> " + retries.toString(), true, screen);
		//if(retries > 2) { sendMail(screen + ": Retries -> " + retries.toString(), true, screen); }

		window.location.href = url;
	})
	.fail(function( error ) {
		sendMail(screen + ": Retries (Fail) -> " + retries.toString(), true, screen);

		if (retries > 4) {
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
			sendMail(screen + ": FAIL & RETRY X= " + retries.toString(), true, screen);
		}
		if(retries < 12) {
			var ret = retries+1;
			setTimeout(() => callUrl(screen, url, ret), 10000);
		} else {
			var msg = screen + ": ERROR: " + error.status + " / " + error.statusText;
			sendMail(msg, false, screen);

			var msg = screen + ": ERROR 1 (Retries=" + retries + "): " + e.status + " / " + e.statusText;
			sendMail(msg, true, screen);
		}
	});
}


function checkUrl(screen, url) {
	// Screen: BAF /BA2 (DEVBUG-16484)
	callUrl(screen, url, 0);
}
/*
 *
 * END ITS-6402
 *
 */

var globalDiscountActive = false;

jQuery(document).ready(function() {
	if (getCookie("discount_code").toLowerCase() == "BlackSale".toLowerCase()) {
		globalDiscountActive = true;

		jQuery('[name="priceValid"]').addClass("linethrough");
		jQuery('[name="priceValidDiscount"]').removeClass("hide");
	} else {
		//document.cookie = "discount_code=BlackSale; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		//jQuery('[name="priceValidDiscount"]').remove();
	}
	
	showAlphabet();

	$("#thumbnail_container_left").click(function(){
		$('#thumbnail_slider').stop().animate({scrollLeft: "-=150"}, 400);
		return false;
	}); 

	$("#thumbnail_container_right").click(function(){
		$('#thumbnail_slider').stop().animate({scrollLeft: "+=150"}, 400);
		return false;
	});

	$('#m_product-img_owl').scroll(function(){
		clearTimeout($.data(this, 'scrollTimer'));
		$.data(this, 'scrollTimer', setTimeout(function() {
			const curScroll = $('#m_product-img_owl').scrollLeft();
			const cnt = $('#m_product-img_owl').children().length + 1;
			const width = $('#m_product-img_owl').width();
			var breakpoints = [];
			while (breakpoints.length <= cnt) {
				breakpoints.push(breakpoints.length * width);
			}

			var closest = breakpoints.reduce(function(prev, curr) {
				return (Math.abs(curr - curScroll) < Math.abs(prev - curScroll) ? curr : prev);
			});

			$('#m_product-img_owl').scrollLeft(closest);
		}, 300));
	});
});

var ayBrands = [];
var ayBrandsExclude = "StyleCommerce,Gertraud Gruber";

jQuery(function () {
	// BrandLine.json Handling
	var filename = "//www.beautyavenue.de/cdn/shop/t/20/assets/brandline.json?v=148207158003166460161745893113";
	var jqxhr = jQuery.getJSON(
		filename,
		function (response) {
			jQuery.each(response.lines,function() {
				var $ay = jQuery(this)[0];
				var synonyms = $ay.brand_synonyms.toLowerCase().split("\|");
				if(!ayBrandsExclude.includes($ay.brand)) {
					ayBrands.push({
						brand		: $ay.brand,
						synonyms	: synonyms,
						url   		: "/collections/" + $ay.brand_collection_url
					});
				}
			}); 
		}
	);

	str_topseller = jQuery('#topseller').text();

	var url = window.location.href;

    if (url.indexOf("/search?q=")>-1 && url.indexOf("type=")==-1){
        // Encode URL params as we have Products with '&'. etc. (same in autocomplete)
        location.assign(url + "*&type=product");
	}
	
	var upcasevendor = "Annemarie Börlind";
	jQuery('[name="vendorcase"]').each(function() {
		// Replace special case
		if(upcasevendor.includes(this.innerText)) {
			this.innerText = this.innerText.toUpperCase();
		}
	});

	// Crappy IE10 hack
	jQuery('#PageMain').find('.checkbox_inactive').on("click", function(e) {
		e.preventDefault();
	});

	jQuery('#search-bar_form input[type=search]').on('keypress', function(e) {
		if(e.which == 10 || e.which == 13) {
			e.preventDefault();
			var vendor = e.target.value.toLowerCase();
			var coll_url = "";

			var json = ayBrands.filter(function (obj) {
				return obj.brand == vendor || obj.synonyms.indexOf(vendor) > -1;
			});

			if(json.length > 0) {
				coll_url = json[0].url;
			} else {
				var json_sorted = aySortedBrands.filter(function (obj) {
					return obj.includes(vendor);
				});

				if(json_sorted.length > 0) {
					coll_url = "/collections/" + json_sorted[0].split("|")[0];
				}
			}
			
			if(coll_url != "") {
				location.assign("https://" + window.location.hostname + coll_url);
			} else {
				location.assign("https://" + window.location.hostname + "/search?type=product&q=" + escape(e.target.form.elements.q.value.replace(" ", "+")));
				//this.form.submit();
			}
		}
	});

	jQuery('#toggle-sidebar').click(function () {
		var s = jQuery('#toggle_sidebar');
		if(s.hasClass('mobile--hide')) { s.removeClass('mobile--hide'); }
		else s.addClass('mobile--hide');
	});
    
	jQuery('[name="disableUpsell"]').on("click", function(e) {
		e.preventDefault();
		jQuery('[name="UpsellCartContainer"]').remove();
		var date = new Date();
		date.setTime(date.getTime()+(30*24*60*60*1000));
		document.cookie = "disable_upsell=true; expires="+date.toUTCString()+";path=/";
	});
});